module.exports = __webpack_public_path__ + "img/Star.6deedfd1.png";